"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkReducer = void 0;
const types_1 = require("./types");
const networkReducer = (state, action) => {
    switch (action.type) {
        case types_1.QueryActionType.REQUEST_IN_FLIGHT:
            return Object.assign(Object.assign({}, state), { hasRun: true, loading: true, err: null, data: null });
        case types_1.QueryActionType.CANCEL_LOADING:
            return Object.assign(Object.assign({}, state), { loading: false });
        case types_1.QueryActionType.REQUEST_FAILED:
            return Object.assign(Object.assign({}, state), { loading: false, err: action.payload, data: null });
        case types_1.QueryActionType.REQUEST_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, err: null, data: action.payload.data, onDoneValue: action.payload.onDoneValue });
        default:
            return state;
    }
};
exports.networkReducer = networkReducer;
